import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import { CallService } from './-call.service';

const API = `${environment.api}/api`;

@Injectable({
  providedIn: 'root'
})
export class SliderService {

  constructor(private http: HttpClient, private callService: CallService) { }

  getSliders(): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/sliders/displayed', httpOptions);
  }
}
